import Vue from "vue";
import { Toast } from "vant";
import Router from "vue-router";

import home from "./home";
import items from "./items";
import user from "./user";
import order from "./order";
import login from "./login";
import ahouse from "./ahouse";
import cms from "./cms";
import vote from "./vote";

const notfound = () =>
  import(/* webpackChunkName: "tabbar-home" */ "@/views/home/notfound.vue");

Vue.use(Router);

let RouterModel = new Router({
  routes: [
    ...home,
    ...items,
    ...user,
    ...order,
    ...login,
    ...cms,
    ...ahouse,
    ...vote,
    {
      path: "/404",
      name: "error",
      components: {
        default: notfound
      },
      meta: {
        hideMenu: true,
        title: "页面未找到"
      }
    },
    {
      path: "*",
      redirect: {
        name: "error"
      },
      meta: {
        hideMenu: true,
        title: "页面未找到"
      }
    }
  ]
});

// ========== 路由历史栈追踪 ==========
const HISTORY_STACK_KEY = '__router_history_stack__';

// 从 sessionStorage 恢复历史栈（刷新时保留）
function loadHistoryStack() {
  try {
    const saved = sessionStorage.getItem(HISTORY_STACK_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (e) {
    return [];
  }
}

function saveHistoryStack() {
  try {
    sessionStorage.setItem(HISTORY_STACK_KEY, JSON.stringify(RouterModel.historyStack));
  } catch (e) {}
}

RouterModel.historyStack = loadHistoryStack();
RouterModel._navAction = null;
RouterModel._goStep = null;

// 获取还能返回多少页
RouterModel.getBackCount = function () {
  return this.historyStack.length - 1;
};

// 判断能否返回
RouterModel.canGoBack = function () {
  return this.historyStack.length > 1;
};

// 拦截导航方法，标记操作类型
const originalPush = RouterModel.push.bind(RouterModel);
const originalReplace = RouterModel.replace.bind(RouterModel);
const originalBack = RouterModel.back.bind(RouterModel);
const originalGo = RouterModel.go.bind(RouterModel);

RouterModel.push = function (...args) {
  RouterModel._navAction = 'push';
  return originalPush(...args);
};
RouterModel.replace = function (...args) {
  RouterModel._navAction = 'replace';
  return originalReplace(...args);
};
RouterModel.back = function () {
  RouterModel._navAction = 'back';
  return originalBack();
};
RouterModel.go = function (n) {
  if (n < 0) {
    RouterModel._navAction = 'back';
    RouterModel._goStep = Math.abs(n);
  }
  return originalGo(n);
};

// 监听浏览器原生回退（左滑、物理返回键、浏览器后退按钮）
window.addEventListener('popstate', function () {
  if (!RouterModel._navAction) {
    RouterModel._navAction = 'back';
    RouterModel._goStep = 1;
  }
});
// ========== END 路由历史栈追踪 ==========

RouterModel.beforeEach((to, from, next) => {
  const { Authorization, user_id } = Vue.prototype.$util.getLocalStorage(
    "Authorization",
    "user_id"
  );
  if (!Authorization && !user_id) {
    if (to.meta.login) {
      RouterModel.push({ name: "login", query: { redirect: to.name } });
      return;
    }
  }
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    let head = document.getElementsByTagName("head");
    let meta = document.createElement("meta");
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // else{
  //   document.title = "工家云"
  // }
  next();
});

RouterModel.afterEach((to, from) => {
  const action = RouterModel._navAction;
  const goStep = RouterModel._goStep || 1;
  RouterModel._navAction = null;
  RouterModel._goStep = null;

  if (action === 'push') {
    RouterModel.historyStack.push(to.fullPath);
  } else if (action === 'replace') {
    if (RouterModel.historyStack.length > 0) {
      RouterModel.historyStack[RouterModel.historyStack.length - 1] = to.fullPath;
    } else {
      RouterModel.historyStack.push(to.fullPath);
    }
  } else if (action === 'back') {
    RouterModel.historyStack.splice(-goStep);
  } else {
    // 首次进入或浏览器前进按钮等未标记的导航
    // 避免刷新时重复入栈（sessionStorage已恢复了当前页）
    const top = RouterModel.historyStack[RouterModel.historyStack.length - 1];
    if (top !== to.fullPath) {
      RouterModel.historyStack.push(to.fullPath);
    }
  }

  saveHistoryStack();
});

export default RouterModel;
